// extracted by mini-css-extract-plugin
export default {"cabecalho":"Cabecalho_cabecalho__ORwa1","cabecalho__container":"Cabecalho_cabecalho__container__u1xDO","cabecalho__input":"Cabecalho_cabecalho__input__3Rspe"};